import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'

import { usePairingStore } from '@/stores/PairingStore.js'
import { useTableStore } from '@/stores/TableStore.js'

const storeID = 'ParticipateStore'

const newParticipate = (name) => ({
    name: name,
    assignedTable: false,
    assignedPairing: false,
    renderColor: null,
    lock: false,
    uuid: uuidv4()
})

export const useParticipateStore = defineStore(storeID, {
    state: () => ({
        participates: []
    }),
    getters: {},
    persist: true,
    actions: {
        get(id) {
            return this.participates.find(participate => participate.uuid === id)
        },
        add(name) {
            let participate = newParticipate(name)
            this.participates.push(participate)

            let tableStore = useTableStore()
            tableStore.createNewTableIdNeeded()
        },
        remove(id) {
            let pairingStore = usePairingStore()
            let tableStore = useTableStore()

            this.participates.forEach((participate, i) => {
                pairingStore.pairings.forEach((pairing) => {
                    pairing.participates.forEach((participateID, i) => {
                        if (participateID === id) {
                            pairing.participates.splice(i, 1)
                        }
                    })
                })

                tableStore.tables.forEach((table) => {
                    table.participates.forEach((participateID, i) => {
                        if (participateID === id) {
                            table.participates.splice(i, 1)
                        }
                    })
                })

                if (participate.uuid === id) {
                    this.participates.splice(i, 1)
                }
            })
        },
        toggleLock(id, lockValue = null) {
            this.participates.forEach((participate) => {
                if (participate.uuid === id) {
                    participate.lock = lockValue ?? !participate.lock
                }
            })
        },
        setAllLocked(lockValue = true) {
            this.participates.forEach((participate) => {
                if (participate.assignedTable === true && participate.lock === !lockValue) {
                    participate.lock = lockValue
                }
            })
        },
        update(id, name) {
            let participate = this.get(id)
            participate.name = name
        },
        setAssignedPairing(id, value) {
            let participate = this.get(id)
            participate.assignedPairing = value
        },
        setAssignedTable(id, value) {
            let participate = this.get(id)
            participate.assignedTable = value
        },
        reset() {
            this.participates = []
        }
    }
})
